import { lazy } from 'react';

export const ReportsMainPageAsync = lazy(() => import('./ReportsMainPage'));
